import type {
  NeedHelpGeneralMailRequest,
  NeedHelpMailRequest,
  NewsFormMailRequest,
} from '~/types/api'
export function createMailRepository() {
  const { $api } = useNuxtApp()
  const { post } = baseRepository($api)

  const DOMAIN = 'mails'
  const DOMAIN_HELP = 'need-help'
  const DOMAIN_HELP_GENERAL = 'need-help-general'
  const DOMAIN_NEWS_FORM = 'news-form'

  async function sendNeedHelp(body: NeedHelpMailRequest) {
    return post<unknown>([DOMAIN, DOMAIN_HELP], { body })
  }

  async function sendNeedHelpGeneral(body: NeedHelpGeneralMailRequest) {
    return post<unknown>([DOMAIN, DOMAIN_HELP_GENERAL], { body })
  }

  async function sendNewsForm(body: NewsFormMailRequest) {
    return post<unknown>([DOMAIN, DOMAIN_NEWS_FORM], { body })
  }

  return {
    sendNeedHelp,
    sendNeedHelpGeneral,
    sendNewsForm,
  }
}
